export default __webpack_public_path__ + "static/media/marketplace.7e1a3ada.svg";